document.addEventListener("DOMContentLoaded", function () {
  let publicAccessToken, storeDomain, apiVersion;
  try {
    strorefrontApiClientData = JSON.parse(
      document.querySelector("#storefront_api_client_data").text
    );
    publicAccessToken = atob(strorefrontApiClientData.public_access_token);
    storeDomain = strorefrontApiClientData.store_domain;
    apiVersion = strorefrontApiClientData.api_version;
  } catch {
    console.error("Fehler beim Parsen der Daten zum Storefront-API-Client");
    throw new Error("Storefront-API-Client konnten nicht geladen werden");
  }

  try {
    window.client = ShopifyStorefrontAPIClient.createStorefrontApiClient({
      storeDomain,
      apiVersion,
      publicAccessToken,
    });
  } catch {
    console.error("Fehler beim Laden des Storefront-API-Clients");
    throw new Error("Storefront-API-Client konnte nicht geladen werden");
  }
});
